import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { NotificationClient } from '@api/api';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { DialogService } from '@shared/services/dialog.service';
import { filter, Observable, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginGuard {
  constructor(
    private msalService: MsalService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService,
    private dialogService: DialogService,
    private notificationClient: NotificationClient
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      switchMap(() => {
        if (this.msalService.instance.getAllAccounts().length > 0) {
          this.promptNotification();
          return of(this.router.parseUrl('/projects'));
        }

        return of(true);
      })
    );
  }

  private promptNotification() {
    this.notificationClient.getNotifications().subscribe({
      next: notificationResponse => {
        if (notificationResponse.notifications?.length > 0) {
          this.dialogService.openInfoDialog(
            'Hinweis',
            notificationResponse.notifications.join('\n')
          );
        }
      },
    });
  }
}
